import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;

export function getAuthHeaders() {
  const token = localStorage.getItem('access_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function authGet(path, config = {}) {
  return axios.get(`${API_URL}${path}`, {
    withCredentials: true,
    headers: { ...getAuthHeaders(), ...config.headers },
    ...config,
  });
}

export function authPost(path, body, config = {}) {
  return axios.post(`${API_URL}${path}`, body, {
    withCredentials: true,
    headers: { ...getAuthHeaders(), ...config.headers },
    ...config,
  });
}

export function authPut(path, body, config = {}) {
  return axios.put(`${API_URL}${path}`, body, {
    withCredentials: true,
    headers: { ...getAuthHeaders(), ...config.headers },
    ...config,
  });
}

export function authDelete(path, config = {}) {
  return axios.delete(`${API_URL}${path}`, {
    withCredentials: true,
    headers: { ...getAuthHeaders(), ...config.headers },
    ...config,
  });
}
